import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwd-tab2',
  templateUrl: './wwdtab2.component.html',
  styleUrls: ['./wwdtabs.component.scss']
})
export class WhatWeDoTab2Component{
  activeTab = 1;

  setActiveTab(tab){
    this.activeTab = tab;
  }
  
}